import './CounterLabel-44fb5d16.css';

var classes = {"CounterLabel":"prc-CounterLabel-CounterLabel-ZwXPe"};

export { classes as default };
